export default __webpack_public_path__ + "images/kai-stone-1.svg";